import React from 'react';

const MirakalousLogo = ({ size = 40, className = "", useImage = false, logoSrc = "/assets/images/mirakalous-logo.png" }) => {
  if (useImage) {
    // Use actual logo image file
    return (
      <div className={`flex items-center justify-center ${className}`} style={{ width: size, height: size }}>
        <img 
          src={logoSrc} 
          alt="Mirakalous Logo" 
          width={size} 
          height={size}
          className="object-contain max-w-full max-h-full"
          onError={(e) => {
            // Fallback to SVG version if image fails to load
            e.target.style.display = 'none';
            e.target.parentNode.innerHTML = `
              <svg width="${size}" height="${size}" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <linearGradient id="mirakalousGradientFallback" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stop-color="#A855F7" />
                    <stop offset="50%" stop-color="#8B5CF6" />
                    <stop offset="100%" stop-color="#06B6D4" />
                  </linearGradient>
                </defs>
                <path 
                  d="M10 90V15C10 10 12 8 17 8C22 8 25 10 25 15V75L40 35C42 30 45 28 50 28C55 28 58 30 60 35L75 75V15C75 10 78 8 83 8C88 8 90 10 90 15V90C90 95 88 97 83 97C78 97 75 95 75 90V40L65 70C63 75 57 75 55 70L50 55L45 70C43 75 37 75 35 70L25 40V90C25 95 22 97 17 97C12 97 10 95 10 90Z" 
                  fill="url(#mirakalousGradientFallback)"
                />
              </svg>
            `;
          }}
        />
      </div>
    );
  }

  // Inline SVG version matching your gradient M design
  return (
    <div className={`flex items-center justify-center ${className}`} style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id={`mirakalousGradient-${Math.random()}`} x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#A855F7" />
            <stop offset="50%" stopColor="#8B5CF6" />
            <stop offset="100%" stopColor="#06B6D4" />
          </linearGradient>
        </defs>
        {/* Stylized M matching your logo design */}
        <path 
          d="M10 90V15C10 10 12 8 17 8C22 8 25 10 25 15V75L40 35C42 30 45 28 50 28C55 28 58 30 60 35L75 75V15C75 10 78 8 83 8C88 8 90 10 90 15V90C90 95 88 97 83 97C78 97 75 95 75 90V40L65 70C63 75 57 75 55 70L50 55L45 70C43 75 37 75 35 70L25 40V90C25 95 22 97 17 97C12 97 10 95 10 90Z" 
          fill={`url(#mirakalousGradient-${Math.random()})`}
        />
      </svg>
    </div>
  );
};

export default MirakalousLogo;
